// Dataset admin API helpers + the shared CatalogueDataset / IntrospectColumn
// types. Lifted out of Admin.tsx so AdminDatasetsTab + EditDatasetPanel can
// import them without dragging in the rest of the legacy users-tab code.

import { accessService } from "../services/accessService";
import type { CatalogueTableMapping } from "../types/dataset.types";

export type CatalogueDataset = {
  id: string;
  department: string;
  icon: string;
  color: string;
  classification: string;
  owner: string;
  ownerEmail: string;
  agentId: string | null;
  description: string;
  tables: CatalogueTableMapping[];
  status: "active" | "coming_soon";
};

export type IntrospectColumn = {
  column_name: string;
  data_type: string;
};

export async function apiGetAdminDatasets(): Promise<CatalogueDataset[]> {
  const res = await accessService.get<CatalogueDataset[]>("/admin/datasets");
  return res.data;
}

export async function apiUpsertDataset(payload: CatalogueDataset): Promise<CatalogueDataset> {
  const res = await accessService.post<CatalogueDataset>("/admin/datasets", payload);
  return res.data;
}

export async function apiDeleteDataset(id: string): Promise<void> {
  await accessService.delete(`/admin/datasets/${encodeURIComponent(id)}`);
}

export async function apiGetSchemas(source: string): Promise<string[]> {
  const res = await accessService.get<string[]>(`/admin/introspect/schemas?source=${source}`);
  return res.data;
}

export async function apiGetViews(source: string, schema: string): Promise<string[]> {
  const res = await accessService.get<string[]>(`/admin/introspect/views?source=${source}&schema=${schema}`);
  return res.data;
}

export async function apiGetColumns(source: string, schema: string, view: string): Promise<IntrospectColumn[]> {
  const res = await accessService.get<IntrospectColumn[]>(`/admin/introspect/columns?source=${source}&schema=${schema}&view=${view}`);
  return res.data;
}

// ID generator used by the dataset add-form when the operator types a
// department name. Only invoked in add mode — edit mode preserves the
// existing dataset.id (the API uses it as a stable PK).
export function slugify(text: string): string {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}
